export default {"src":"/_next/static/media/logo.58d9cf01.svg","height":24,"width":170,"blurWidth":0,"blurHeight":0};